let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kwJBr")).then(() => parcelRequire('3tyT4'));